import { Utils } from './utils';
import { Forms } from './forms';
const formSelector = ".newsletter-signup-form";
const validationRules = {
    email: {
        required: true,
        email: true
    },
    privacyPolicyAccepted: {
        required: true
    }
};
const validationMessages = {
    email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
    },
    privacyPolicyAccepted: {
        required: "Please accept our privacy policy"
    }
};
/**
 * Initializes form validation and submission for the Newsletter signup form, with the GAEvent object configured for tracking.
 * @param formSelector The CSS selector for the form to be validated.
 * @param validationRules The validation rules to be applied to the form fields.
 * @param validationMessages The validation messages to be displayed for each field.
 */
function initializeFormValidation(formSelector, validationRules, validationMessages = undefined) {
    const { landingPage, conversionPagePath, gtmCode, spotCode, campaignName, campaignTerm, campaignMedium } = Utils.GetTrackingDataFromHiddenFields();
    let newsletterSignupGAEvent = {
        event: 'newsletter_submission',
        attributes: {
            landingPage: landingPage,
            conversionPagePath: conversionPagePath,
            gtmCode: gtmCode,
            source: spotCode,
            campaignName: campaignName,
            campaignTerm: campaignTerm,
            campaignMedium: campaignMedium,
        }
    };
    Forms.initializeFormValidation(formSelector, validationRules, validationMessages, newsletterSignupGAEvent);
}
export class NewsletterSignup {
    /**
     * If the page contains any newsletter signup forms, initialize the validation settings for those forms. Not all
     * forms are validated this way.
     */
    InitializeFormValidation() {
        initializeFormValidation(formSelector, validationRules, validationMessages);
    }
}
